import { render, staticRenderFns } from "./JeecgOrderModalForJEditableTable.vue?vue&type=template&id=1185fe7e&scoped=true"
import script from "./JeecgOrderModalForJEditableTable.vue?vue&type=script&lang=js"
export * from "./JeecgOrderModalForJEditableTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1185fe7e",
  null
  
)

export default component.exports